import { Navigate, Outlet } from "react-router-dom";

import { useAuth } from "$context/AuthContextProvider";

const ProtectedRoute = () => {
  const auth = useAuth();

  return auth.bearerToken ? <Outlet /> : <Navigate to={"/login"} replace />;
};

export default ProtectedRoute;
